class ShellPartnerModel {
  id;
  description;
  image;
  isComingSoon;
  isEnabled;
  order;
  title;

  constructor(options = {}) {
    this.id = options.id;
    this.description = options.description;
    this.image = options.image;
    this.isComingSoon = options.isComingSoon;
    this.isEnabled = options.isEnabled;
    this.order = options.order;
    this.title = options.title;
  }
}

export default ShellPartnerModel;
